import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { FALLBACK_LANGUAGE } from './constants';

import bnINJSON from '../translations/locales/bn-in';
import daDKJSON from '../translations/locales/da-dk';
import deDEJSON from '../translations/locales/de-de';
import enAUJSON from '../translations/locales/en-au';
import enCAJSON from '../translations/locales/en-ca';
import enIEJSON from '../translations/locales/en-ie';
import enNZJSON from '../translations/locales/en-nz';
import enGBJSON from '../translations/locales/en-gb';
import enUSJSON from '../translations/locales/en-us';
import esESJSON from '../translations/locales/es-es';
import esUSJSON from '../translations/locales/es-us';
import frFRJSON from '../translations/locales/fr-fr';
import frCAJSON from '../translations/locales/fr-ca';
import itITJSON from '../translations/locales/it-it';
import jaJPJSON from '../translations/locales/ja-jp';
import koKRJSON from '../translations/locales/ko-kr';
import nlBEJSON from '../translations/locales/nl-be';
import nlNLJSON from '../translations/locales/nl-nl';
import ptBRJSON from '../translations/locales/pt-br';
import zhCNJSON from '../translations/locales/zh-cn';
import zhHKJSON from '../translations/locales/zh-hk';

type JSONObject = { [key: string]: unknown };

export const languages: {
  [lng: string]: { name: string; nativeName: string; json: JSONObject };
} = {
  'en-AU': {
    name: 'Australia',
    nativeName: 'Australia',
    json: enAUJSON,
  },
  'nl-BE': {
    name: 'Belgium (Dutch)',
    nativeName: 'Belgium',
    json: nlBEJSON,
  },
  'pt-BR': {
    name: 'Brazil',
    nativeName: 'Brasil',
    json: ptBRJSON,
  },
  'en-CA': {
    name: 'Canada (English)',
    nativeName: 'Canada (English)',
    json: enCAJSON,
  },
  'fr-CA': {
    name: 'Canada (French)',
    nativeName: 'Canada (Français)',
    json: frCAJSON,
  },
  'de-DE': {
    name: 'German',
    nativeName: 'Deutschland',
    json: deDEJSON,
  },
  'da-DK': {
    name: 'Danish',
    nativeName: 'Danmark',
    json: daDKJSON,
  },
  'es-US': {
    name: 'United States (Spanish)',
    nativeName: 'Español (Intl.)',
    json: esUSJSON,
  },
  'es-ES': {
    name: 'Spain',
    nativeName: 'España',
    json: esESJSON,
  },
  'fr-FR': {
    name: 'France',
    nativeName: 'France',
    json: frFRJSON,
  },
  'bn-IN': {
    name: 'Bengali (India)',
    nativeName: 'India',
    json: bnINJSON,
  },
  'en-IE': {
    name: 'Ireland',
    nativeName: 'Ireland',
    json: enIEJSON,
  },
  'it-IT': {
    name: 'Italy',
    nativeName: 'Italia',
    json: itITJSON,
  },
  'nl-NL': {
    name: 'Netherlands',
    nativeName: 'Nederland',
    json: nlNLJSON,
  },
  'en-NZ': {
    name: 'New Zealand',
    nativeName: 'New Zealand',
    json: enNZJSON,
  },
  'en-GB': {
    name: 'United Kingdom',
    nativeName: 'United Kingdom',
    json: enGBJSON,
  },
  'en-US': {
    name: 'English',
    nativeName: 'USA',
    json: enUSJSON,
  },
  'ja-JP': {
    name: 'Japan',
    nativeName: '日本',
    json: jaJPJSON,
  },
  'zh-HK': {
    name: 'Hong Kong (Traditional)',
    nativeName: '香港',
    json: zhHKJSON,
  },
  'zh-CN': {
    name: 'China (Simplified)',
    nativeName: '简体中文',
    json: zhCNJSON,
  },
  'ko-KR': {
    name: 'Korea (South)',
    nativeName: '대한민국',
    json: koKRJSON,
  },
};

const resources = Object.keys(languages).reduce(
  (acc: { [lng: string]: JSONObject }, lang: string) => {
    acc[lang] = languages[lang].json;
    return acc;
  },
  {}
);

export const SupportedLanguages = Object.keys(resources).map((key) => ({
  key,
  name: languages[key].name,
  nativeName: languages[key].nativeName,
}));

i18n.use(initReactI18next).use(LanguageDetector).init({
  debug: true,
  resources,
  lng: navigator.language,
  fallbackLng: FALLBACK_LANGUAGE,
});

export const getLanguage = () => {
  console.log('getting language', i18n.language);
  return (
    i18n.language ||
    (typeof window !== 'undefined' && window.localStorage.i18nextLng) ||
    FALLBACK_LANGUAGE
  ).toLowerCase();
};

export const setLanguage = (lng: string) => {
  console.log('setting language', lng.toLowerCase());
  i18n.changeLanguage(lng.toLowerCase());
};
